<template>
  <div>
    <cc-kc-census />
  </div>
</template>

<script>
// 获取接口地址
import CcKcCensus from '@/components/tjbb/ccKcCensus.vue'

export default {
  name: 'Cckctj',
  components: {
    // sideMenu,
    // Header,
    CcKcCensus
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
